import {forwardRef} from 'react';
import {join} from '../../utils';
import {OnHoverTooltip} from '../../tooltip';
import {Selectors} from '../button.selectors';
import {ButtonProps} from '../types';

import styles from './button.module.less';

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
	({className, title, ...props}, ref) => {
		const btn = <button data-cy={Selectors.Gray}
		                    ref={ref}
		                    {...props}
		                    className={join(styles.button, className)}/>;

		if (title) {
			return <OnHoverTooltip message={title}>{btn}</OnHoverTooltip>;
		} else {
			return btn;
		}
	}
);

export default Button;
